// mds-dojo — FAITHFUL port of dojo/_base/event (dojo 1.x), evergreen.
// Additive canonical dep (none existed before); dojox/calendar uses event.stop (36x).
// IE branch (window.event / on._preventDefault / cancelBubble) collapsed to the
// evergreen preventDefault()+stopPropagation() path. on._fixEvent normalization is
// preserved when present (mds dojo/on does not expose it, so fix() is identity).
import on from '../on';

if ((on as any)._fixEvent) {
	var fixEvent = (on as any)._fixEvent;
	(on as any)._fixEvent = function (evt: any, se: any) {
		evt = fixEvent(evt, se);
		return evt;
	};
}

var ret = {
	// summary:
	//		This module defines dojo DOM event API. Usually you should use dojo/on, and
	//		evt.stopPropagation() + evt.preventDefault(), rather than this module.

	fix: function (/*Event*/ evt: any, /*DOMNode*/ sender: any) {
		if ((on as any)._fixEvent) {
			return (on as any)._fixEvent(evt, sender);
		}
		return evt;	// Event
	},

	stop: function (/*Event*/ evt: any) {
		// summary:
		//		prevents propagation and clobbers the default action of the passed event
		if (evt && evt.preventDefault) {
			evt.preventDefault();
			evt.stopPropagation();
		}
	}
};

export default ret;
